/**
 * 筋特征正式提交执行器。
 */

import type { Viewer } from '../../../../viewer';
import { RibCommandAdapter } from '../../../command/rib/RibCommandAdapter';
import type { RibFeatureDefinitionModel } from '../../../definition/rib/RibFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import type { RibFeaturePrototype } from '../../../prototype/rib/RibFeaturePrototype';
import type { FeatureExecutionRuntime } from '../../FeatureExecutionRuntime';
import { FeatureCommitExecution } from '../FeatureCommitExecution';

/**
 * 筋特征正式提交执行器。
 */
export class RibCommitExecution extends FeatureCommitExecution<
    RibFeatureDefinitionModel,
    RibFeaturePrototype
> {
    /** 执行运行时。 */
    private readonly runtime: FeatureExecutionRuntime;
    /** 替换命令通道。 */
    private readonly replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>;
    /** 命令适配器。 */
    private readonly adapter: RibCommandAdapter;

    /**
     * @param _viewer Viewer 实例。
     * @param runtime 执行运行时。
     * @param replaceFeatureCommand 替换命令回调。
     */
    public constructor(
        _viewer: Viewer,
        runtime: FeatureExecutionRuntime,
        replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>,
    ) {
        super();
        this.runtime = runtime;
        this.replaceFeatureCommand = replaceFeatureCommand;
        this.adapter = new RibCommandAdapter();
    }

    /**
     * @inheritdoc
     */
    public async commitCreate(prototype: RibFeaturePrototype): Promise<string> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        const result = await this.runtime.executeCommand(command);
        return result.objectId;
    }

    /**
     * @inheritdoc
     */
    public async commitEdit(
        session: FeatureEditSession<RibFeatureDefinitionModel, RibFeaturePrototype>,
        prototype: RibFeaturePrototype,
    ): Promise<boolean> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        return this.replaceFeatureCommand(session.getPrototype().getFeatureId(), command);
    }
}
